export const recordsObject = {
    recordData: null,
    userSectionStats: null,
    monthlyAccuracyData: null,
    dailyAccuracyTrend: null,
    isLoading: false,
    isLoadingMonthlyAccuracy: false,
    isLoadingDailyTrend: false,
    error: null,
};
